import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import SessionAuthProvider from 'Src/common/providers/sessionAuth';
import DirectoryDetails from 'Src/alumniDirectories/containers/Details';
import { DEFAULT_PAGE_PATH } from 'Src/alumniDirectories/routes';

import 'Src/common/arc.scss';
import '../style.scss';

const renderComponentToContainer = (container) => {
  if (container) {
    ReactDOM.render(
      <Auth0Provider
        domain={window.auth0TenantDomain}
        clientId={window.auth0ClientId}
        redirectUri={`${window.location.origin}/d/auth0/callback`}
        onRedirectCallback={() => {}}
        cacheLocation="localstorage"
        useRefreshTokens>
        <SessionAuthProvider>
          <Router>
            <Switch>
              <Route path={DEFAULT_PAGE_PATH} component={DirectoryDetails} />
            </Switch>
          </Router>
        </SessionAuthProvider>
      </Auth0Provider>,
      container,
    );
  }
};

renderComponentToContainer(document.getElementById('root'));
